(function LivePlannerEndSessionTripSummary($, Adzuki)
{
	"use strict";

	$(document).ready(function documentReady()
	{
		$(document).on('trip_summary_modal_open', function onload(event)
		{
			event.stopImmediatePropagation();
			let $trip_summary_modal = $('#session_trip_modal .carousel-container');
			if ($trip_summary_modal.length > 0) {
				$trip_summary_modal.each(function handle() {
					insertNumbers($(this));
					insertDots($(this));
					
					$(this).children('.prev').click({current_carousel: $(this)}, function prevButtonClicked(event) {
						minusItem(event.data.current_carousel);
					});
					
					$(this).children('.next').click({current_carousel: $(this)}, function nextButtonClicked(event) {
						plusItem(event.data.current_carousel);
					});
					
					$(this).children('.carousel_dots').children('.dot').click({current_carousel: $(this)}, function dotButtonClicked(event) {
						let carousel_item_index 	= $(this).attr('data-item-count');
						let current_carousel 		= event.data.current_carousel;
						
						let active_carousel_item 	= currentItem(current_carousel);
						let next_carousel_item 		= $(current_carousel.children('.item')[carousel_item_index]);
						
						showItems(next_carousel_item, active_carousel_item, current_carousel);
					});
				});
			}
		});
	});
	
	/**
	 * Inserts the dots counters at the bottom of the carousel
	 * @param carousel
	 */
	function insertDots(carousel) {
		let carousel_length = carousel.children('.item').length;
		for (let i = 0; i < carousel_length; i++) {
			let dot_div_string = '<div class="dot" data-item-count="' + i +'"></div>';
			if (i === 0) {
				dot_div_string = '<div class="dot active" data-item-count="' + i +'"></div>';
			}
			$('.carousel_dots').append(dot_div_string);
		}
	}
	
	/**
	 * Adds the page slider counter for the carousel
	 * @param carousel
	 */
	function insertNumbers(carousel) {
		let carousel_length = carousel.children('.item').length;
		for (let i = 0; i < carousel_length; i++) {
			let number_text_string = '<div class="numbertext">'+ (i + 1) + '/' + carousel_length + '</div>';
			let child_item = carousel.children('.item')[i];
			$(child_item).append(number_text_string);
		}
	}
	
	/**
	 * Slides the carousel to the left item
	 * @param carousel
	 */
	function minusItem(carousel) {
		let active_carousel_item = currentItem(carousel);
		if (active_carousel_item.prev('.item').length > 0) {
			let prev_carousel_item = active_carousel_item.prev('.item');
			showItems(prev_carousel_item, active_carousel_item, carousel);
		} else {
			showItems(carousel.children('.item').last(), active_carousel_item, carousel);
		}
	}
	
	/**
	 * Slides the carousel to the right item
	 * @param carousel
	 */
	function plusItem(carousel) {
		let active_carousel_item = currentItem(carousel);
		if (active_carousel_item.next('.item').length > 0) {
			let next_carousel_item = active_carousel_item.next('.item');
			showItems(next_carousel_item, active_carousel_item, carousel);
		} else {
			showItems($(carousel.children('.item')[0]), active_carousel_item, carousel);
		}
	}
	
	/**
	 * Displays the next carousel item
	 * @param next_carousel_item
	 * @param active_carousel_item
	 * @param carousel the current carousel
	 */
	function showItems(next_carousel_item, active_carousel_item, carousel) {
		if (next_carousel_item !== undefined) {
			let active_dot_index 	= active_carousel_item.attr('data-dot-count');
			let next_dot_index 		= next_carousel_item.attr('data-dot-count');
			
			// Handle CSS
			active_carousel_item.css('display', 'none');
			next_carousel_item.css('display', 'block');
			
			let carousel_dot_elements = $(carousel.children('.carousel_dots').children('.dot'));
			
			if (carousel_dot_elements.length > 0) {
				$(carousel_dot_elements[active_dot_index]).removeClass('active');
				$(carousel_dot_elements[next_dot_index]).addClass('active');
			}
		}
	}
	
	/**
	 * Returns the currently active carousel item
	 * @param carousel
	 * @returns {*}
	 */
	function currentItem(carousel) {
		return carousel.children('.item[style*="display: block"]');
	}
}(jQuery, window.Adzuki || {}));